var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import './Manager.scss';
import { Component } from 'decorators';
import { debounce } from 'data/function';
import deleteFunctionModal from '../deleteFunctionModal';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { ActionService } from '../../../../services/ActionService';
import { FunctionService } from '../../../../services/FunctionService';
import ActionsManageFunctionView from './ActionsManageFunctionView.html';
import { FunctionViewModel } from '../../../../models/viewModels/FunctionViewModel';
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
let ActionsManageFunctionComponent = class ActionsManageFunctionComponent {
    static $inject = ['ngToast', 'ActionService', 'FunctionService', 'BlipToastService', 'BuilderSegmentService', '$translate', 'ModalService'];
    constructor(ngToast, ActionService, FunctionService, BlipToastService, BuilderSegmentService, $translate, ModalService) {
        'ngInject';
        this.ngToast = ngToast;
        this.ActionService = ActionService;
        this.FunctionService = FunctionService;
        this.BlipToastService = BlipToastService;
        this.BuilderSegmentService = BuilderSegmentService;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.isLoading = true;
        this.itemHeight = 70;
        this.maxHeight = 330;
        this.CREATE_FUNCTION_SCREEN = 'createFunction';
        this.MANAGE_FUNCTION_SCREEN = 'manageFunction';
        this.MAIN_SCREEN = '';
        this.onOpenEditFunction = (event) => {
            this.actions.description = event.func.functionDescription;
            this.actions.key = event.func.functionId;
            this.actions.functionName = event.func.functionName;
            this.actions.functionContent = event.func.functionContent;
            this.actions.inputVariables =
                event.func.functionParameters &&
                    event.func.functionParameters.trim() !== ''
                    ? event.func.functionParameters.split(',')
                    : [];
            this.BuilderSegmentService.trackBlockActionLibraryMoreOptions({
                Location: 'Library',
                Choice: 'Edit',
                Description: 'Quando o usuário clica em alguma opção dentro do ícone ’Mais opções’ na listagens de funções',
            });
            this.ActionService.setActions(this.actions);
            this.ActionService.setStatusNewFunction(false);
            this.ActionService.setIsEditing(true);
            this.ActionService.setState('manageFunction');
            this.setActiveComponent({ component: 'createFunction' });
        };
        this.filterFunctions = (event) => {
            this.filterFunctionName = event.detail.value;
            this.filterFunctionListByName(this.filterFunctionName);
        };
        this.filterFunctionListByName = (filter) => {
            if (filter) {
                this.filteredFunctions = this.filteredFunctions.filter(func => func.functionName.toLowerCase().includes(filter.toLowerCase()));
            }
            else {
                this.filteredFunctions = [...this.allFunctions];
            }
        };
        this.filterFunctionName = '';
        this.allFunctions = [];
        this.filteredFunctions = [];
        this.actions = this.ActionService.getActions();
        this.debouncedSearch = debounce(this.filterFunctions, 500);
    }
    $onInit() {
        this.Initialize();
        const buttons = document.querySelectorAll('#copy-action');
        buttons.forEach(button => {
            button.style.display = 'none';
        });
    }
    $onDestroy() {
        const buttons = document.querySelectorAll('#copy-action');
        buttons.forEach(button => {
            button.style.display = '';
        });
    }
    async Initialize() {
        if (!this.actions) {
            this.actions = new FunctionViewModel();
        }
        try {
            this.allFunctions = await this.FunctionService.getAllFunctions();
            await new Promise(resolve => setTimeout(resolve, 1000));
            this.filteredFunctions = [...this.allFunctions];
            this.isLoading = false;
            this.ActionService.setAllFunctions(this.allFunctions);
        }
        catch (e) {
            console.error(e);
            this.allFunctions = [];
            this.filteredFunctions = [...this.allFunctions];
            this.isLoading = false;
            this.ActionService.setAllFunctions(this.allFunctions);
        }
    }
    getContainerHeight() {
        const visibleItemsCount = this.filteredFunctions.length;
        const height = Math.min(visibleItemsCount * this.itemHeight, this.maxHeight);
        return `${height}px`;
    }
    async showDeleteFunctionUniqueModal() {
        const modal = await this.ModalService.showModal(deleteFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            await this.delete();
        }
    }
    async showDeleteFunctionMultipleModal() {
        const modal = await this.ModalService.showModal(deleteFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
    }
    async handleDeleteWithId(event) {
        this.actions.key = event.func.functionId;
        this.actions.functionName = event.func.functionName;
        this.actions.functionContent = event.func.functionContent;
        this.actions.inputVariables =
            event.func.functionParameters &&
                event.func.functionParameters.trim() !== ''
                ? event.func.functionParameters.split(',')
                : [];
        this.actions.description = event.func.functionDescription;
        await this.handleDelete();
        this.Initialize();
    }
    async delete() {
        try {
            if (this.actions.key) {
                if (this.applications.length === 1) {
                    await this.deleteFunctionWithApplication(this.applications[0].applicationIdentity, this.applications[0].functionId);
                }
                await this.FunctionService.deleteFunction(this.actions.key);
                this.BuilderSegmentService.trackBlockActionLibraryDeleteFunction({
                    Location: 'Library',
                    Description: 'É disparado quando o usuário está na tela de edição da função e clica no botão de excluir.',
                });
                this.BlipToastService.show('success', {
                    msg: this.$translate.instant('builder-tabs-actions.message.success.deleted'),
                    duration: 5000,
                });
            }
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.message.error.deleted'),
                duration: 5000,
            });
        }
    }
    async deleteFunctionWithApplication(applicationIdentity, functionId) {
        try {
            await this.FunctionService.deleteFunctionWithApplication(applicationIdentity, functionId);
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.message.error.deleted'),
                duration: 5000,
            });
        }
    }
    async handleDelete() {
        try {
            this.ActionService.setActions(this.actions);
            const applicationsWithFunction = await this.FunctionService.getApplicationsOfAFunction(this.actions.key);
            this.applications = applicationsWithFunction;
            this.actions.applications = applicationsWithFunction;
            this.applications.forEach(application => {
                const serverUrl = window.location.origin;
                application.url = `${serverUrl}/application/detail/${application.applicationIdentity}/templates/builder/`;
            });
            this.BuilderSegmentService.trackBlockActionLibraryDeleteFunction({
                Location: 'Library',
                Description: 'É disparado quando o usuário está na tela de edição da função e clica no botão de excluir.',
            });
            switch (applicationsWithFunction.length) {
                case 0:
                    await this.showDeleteFunctionUniqueModal();
                    break;
                default:
                    await this.showDeleteFunctionMultipleModal();
                    break;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    closeManager() {
        if (this.onActionDeleted) {
            this.onActionDeleted({ actions: this.actions });
        }
        this.setActiveComponent({ component: '' });
    }
    handleFilterChange(filterText) {
        const filteredActions = this.actions.inputVariables.filter((action) => action.name.toLowerCase().includes(filterText.toLowerCase()));
        this.BuilderSegmentService.trackBlockActionLibrarySearch({
            Location: 'Library',
            Description: 'Quando o usuário pesquisa algo no campo de input',
        });
        if (this.onActionChanged) {
            this.onActionChanged({ actions: filteredActions });
        }
    }
    createNewFunction() {
        this.ActionService.setStatusNewFunction(true);
        this.ActionService.setState('manageFunction');
        this.setActiveComponent({ component: 'createFunction' });
    }
};
ActionsManageFunctionComponent.$inject = ['ngToast', 'ActionService', 'FunctionService', 'BlipToastService', 'BuilderSegmentService', '$translate', 'ModalService'];
ActionsManageFunctionComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: ActionsManageFunctionView,
        bindings: {
            actions: '<',
            onActionChanged: '&',
            onActionDeleted: '&',
            setActiveComponent: '&',
        },
    }),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof ActionService !== "undefined" && ActionService) === "function" ? _a : Object, typeof (_b = typeof FunctionService !== "undefined" && FunctionService) === "function" ? _b : Object, typeof (_c = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _c : Object, typeof (_d = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _d : Object, typeof (_f = typeof angular !== "undefined" && (_e = angular.translate) !== void 0 && _e.ITranslateService) === "function" ? _f : Object, Object])
], ActionsManageFunctionComponent);
export { ActionsManageFunctionComponent };
